module.exports = __webpack_public_path__ + "img/drawFade2.4f001303.png";